import AxiosConfig from './serverAxiosConfig'
import firebase from '../config/FirebaseConfig'

/*
  This endpoint was used to capture feedback from users on which platforms they would be most excited to see in Spyder.
  The survey ran from Aug 18th 6pm to Aug 21st 5pm.
  The results can be found in Notion: https://app.notion.com/p/foreplayos/3c025afdb41e8099aafffedf8f0402af?v=3c025afdb41e8043aac4000c983dd5ef&source=copy_link
*/
const submitSpyderPlatformSurvey = async (platforms, details, teamId = null) => {
  const { Aa: token } = firebase.auth().currentUser

  const body = {
    platforms,
    details
  }
  if (teamId) body.teamId = teamId

  await AxiosConfig.post(
    'notion/survey/spyder-platforms',
    body,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
}

export default {
  submitSpyderPlatformSurvey
}